import Typography from 'Components/Base/Typography'
import React, { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components'

export default function NotEligible() {
  const theme = useTheme()
  const [isMobile, setIsMobile] = useState<boolean>(false)

  const setMobileSetting = () => {
    if (window.innerWidth < 800) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  useEffect(() => {
    setMobileSetting()
    window.addEventListener('resize', () => {
      setMobileSetting()
    })
  }, [])

  return (
    <Container>
      <Header>No Eligible Services Found</Header>
      <Typography size={20} styles={{ maxWidth: 650, marginLeft: 'auto', marginRight: 'auto' }}>
        Thanks for signing up! While your account was created successfully, it looks like you're not currently eligible for our services.
      </Typography>
      <Typography size={20} styles={{ fontWeight: 'bold', marginTop: 15, marginBottom: 10 }}>
        This could be because:
      </Typography>
      <Ul>
        <li>
          <Typography size={20}>We haven’t received your information from your health insurance provider yet</Typography>
        </li>
        <li>
          <Typography size={20}>Your plan doesn’t include access to our services</Typography>
        </li>
      </Ul>
      <Typography size={20} styles={{ marginTop: 60, marginBottom: 20 }}>
        If you think this might be a mistake or have questions, we’re here to help:
      </Typography>
      <Ul>
        <Li>
          <Typography size={20}>Call us at 1.888.799.8742</Typography>
        </Li>
        <Li>
          <Typography size={20}>
            Chat with a{' '}
            <a href="https://medchatapp.com/widget/60qB-Pr0gEeAOYuH7bhHNw/chat" target="_blank" rel="noreferrer">
              live agent
            </a>
          </Typography>
        </Li>
      </Ul>
    </Container>
  )
}

const Container = styled.div`
  font-family: Raleway;
  text-align: center;
  max-width: 1200px;
  margin: auto;
  padding: 130px 10px;
  justify-content: center;
  @media only screen and (max-width: 600px) {
    padding: 30px 20px;
  }
`

const Header = styled.h1`
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 40px;
`

const Ul = styled.ul`
  max-width: 600px;
  margin-top: 2;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
`
const Li = styled.li`
  width: 250px;
  margin-left: auto;
  margin-right: auto;
`
